import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71e5a15a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "label font-medium font-sans lg:text-3xl md:text-2xl text-lg" }

import { IconsName } from "@/utils/icons";
import { PlayableInstrument } from "@/utils/instruments";
import { useJingle } from "@/utils/jingles";
import {
  AnimationListOptions,
  MotionKeyframesDefinition,
} from "@motionone/dom";
import { Motion } from "motion/vue";
import { computed, ref } from "vue";
import Icon from "./Icon.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    icon: null,
    label: null,
    instrument: null,
    direction: null
  },
  emits: ["open"],
  setup(__props: any) {

const props = __props as {
  icon: keyof typeof IconsName;
  label: string;
  instrument: keyof typeof PlayableInstrument;
  direction?: "left" | "right";
}




const playJingle = useJingle(props.instrument as PlayableInstrument);

const transitioning = ref(false);
const transitionAnimation = computed<MotionKeyframesDefinition>(() =>
  transitioning.value
    ? {
        width: ["100%", "max(200vw, 250vh)"],
        height: ["100%", "max(200vw, 250vh)"],
      }
    : {}
);
const transitionTransition: AnimationListOptions = {
  duration: 0.6,
  easing: "ease-in",
};

const contentFadeOut = computed<MotionKeyframesDefinition>(() =>
  transitioning.value ? { opacity: 0 } : {}
);
const contentFadeOutOptions: AnimationListOptions = {
  delay: 0.3,
  duration: 0.5,
  easing: "ease-in",
};

const startTransition = () => {
  transitioning.value = true;

  // Play a jingle
  let amount = 0;
  const delays: number[] = [];
  if (props.instrument === PlayableInstrument.drum) {
    amount = 4 + Math.round(Math.random() * 3);
    delays.push((110 / (8 * 60)) * 1000);
  }
  if (props.instrument === PlayableInstrument.rhodes) {
    amount = 2 + Math.round(Math.random() * 1);
    for (let i = 0; i < amount; i++) {
      delays.push(350 + Math.random() * 600);
    }
  }
  if (props.instrument === PlayableInstrument.clarinet) {
    amount = 3 + Math.round(Math.random() * 1);
    delays.push(300 + Math.random() * 300);
  }
  if (props.instrument === PlayableInstrument.synth) {
    amount = 2 + Math.round(Math.random() * 2);
    delays.push(300 + Math.random() * 400);
  }
  playJingle(amount, delays);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass({
      [`relative
      bg-secondary
      md:rounded-full
      w-full
      h-12
      md:w-28 md:h-28 md:hover:w-48 md:hover:h-48 md:focus:w-48 md:focus:h-48
      lg:w-40 lg:h-40 lg:hover:w-64 lg:hover:h-64 lg:focus:w-64 lg:focus:h-64
      focus:outline-none
      text-white
      page-button`]: true,
      'z-30': transitioning.value,
      'cursor-default': transitioning.value,
    }),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (startTransition())),
    disabled: transitioning.value
  }, [
    _createVNode(_unref(Motion), {
      class: _normalizeClass(`
        absolute
        z-0
        left-1/2
        top-1/2
        bg-secondary
        md:rounded-full
        transition-bg
        max-w-full
        md:max-w-none
      `),
      animate: _unref(transitionAnimation),
      transition: transitionTransition,
      onMotioncomplete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open')))
    }, null, 8, ["animate"]),
    _createVNode(_unref(Motion), {
      animate: _unref(contentFadeOut),
      transition: contentFadeOutOptions,
      class: _normalizeClass({
        [`content
        absolute
        top-0
        w-full
        h-full
        flex
        md:flex-col md:justify-center
        gap-4
        md:gap-0
        justify-start
        items-center
        px-2
        md:px-0
        transition-opacity
        duration-200
        opacity-30`]: true,
        'flex-row-reverse': __props.direction === 'right',
      })
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          name: __props.icon,
          size: "l"
        }, null, 8, ["name"]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1)
      ]),
      _: 1
    }, 8, ["animate", "class"])
  ], 10, _hoisted_1))
}
}

})